export type Thing = {
  id: string;
  name: string;
  emoji: string;
  wikiTitle: string;
  category: string;
  blurb: string;
  imageUrl?: string;
  tags?: string[];
  score: number;
  wins: number;
  losses: number;
};

export const STARTING_THINGS: Thing[] = [
  { id: 'internet', name: 'Internet', emoji: '🌐', wikiTitle: 'Internet', category: 'all time #1', tags: ['tech','civilization','chaos'], blurb: 'The infinite argument machine. Somehow contains every other awesome thing.', imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Internet_map_1024.jpg/640px-Internet_map_1024.jpg', score: 2310, wins: 3810, losses: 1464 },
  { id: 'star-wars', name: 'Star Wars', emoji: '✨', wikiTitle: 'Star_Wars', category: 'space mythology', tags: ['movie','space','nerd'], blurb: 'Laser swords, destiny, villains breathing like broken machinery. Eternal top ten.', score: 2265, wins: 3440, losses: 1502 },
  { id: 'super-mario-bros-3', name: 'Super Mario Bros. 3', emoji: '🍄', wikiTitle: 'Super_Mario_Bros._3', category: 'video game royalty', tags: ['game','nostalgia','cartoon'], blurb: 'Tanooki suit. World map. Peak cartridge-era magic.', score: 2218, wins: 3188, losses: 1394 },
  { id: 'tetris', name: 'Tetris', emoji: '▣', wikiTitle: 'Tetris', category: 'falling blocks', tags: ['game','math','soviet'], blurb: 'Soviet geometry that conquered every brain on Earth.', score: 2184, wins: 3099, losses: 1418 },
  { id: 'google-maps', name: 'Google Maps', emoji: '🗺️', wikiTitle: 'Google_Maps', category: 'civilization tech', tags: ['tech','utility','civilization'], blurb: 'Ended getting lost. Also started arguments about better routes.', score: 2148, wins: 2890, losses: 1377 },
  { id: 'meat', name: 'Meat', emoji: '🥩', wikiTitle: 'Meat', category: 'primitive fuel', tags: ['food','caveman','protein'], blurb: 'Fire plus protein: the ancient cheat code.', score: 2110, wins: 2702, losses: 1442 },
  { id: 'yosemite', name: 'Yosemite', emoji: '🏞️', wikiTitle: 'Yosemite_National_Park', category: 'nature flex', tags: ['nature','place','majestic'], blurb: 'Cliffs so dramatic they look like the Earth hired an art director.', score: 2075, wins: 2550, losses: 1371 },
  { id: 'terminator', name: 'Terminator', emoji: '🤖', wikiTitle: 'Terminator_(character)', category: 'killer robot', blurb: 'Chrome skeleton nightmare with perfect catchphrase discipline.', score: 2044, wins: 2440, losses: 1341 },
  { id: 'lightsaber-real', name: 'Lightsaber (Real)', emoji: '⚔️', wikiTitle: 'Lightsaber', category: 'impossible weapon', blurb: 'If this existed, civilization would become 80% duels instantly.', score: 2010, wins: 2360, losses: 1285 },
  { id: 'tacos', name: 'Tacos', emoji: '🌮', wikiTitle: 'Taco', category: 'handheld perfection', blurb: 'Portable flavor architecture. Structurally unstable, spiritually flawless.', score: 1984, wins: 2290, losses: 1210 },
  { id: 'black-holes', name: 'Black Holes', emoji: '🕳️', wikiTitle: 'Black_hole', category: 'cosmic menace', tags: ['space','death','science'], blurb: 'Reality’s final boss. Eats light, bends time, refuses to elaborate.', score: 1840, wins: 42, losses: 8 },
  { id: 'samurai', name: 'Samurai', emoji: '🗡️', wikiTitle: 'Samurai', category: 'warrior class', blurb: 'Honor, steel, impossible drip. Historically overpowered aesthetics.', score: 1765, wins: 38, losses: 13 },
  { id: 'pizza', name: 'Pizza', emoji: '🍕', wikiTitle: 'Pizza', category: 'food tech', tags: ['food','party','civilization'], blurb: 'The circular proof that civilization was worth it.', score: 1912, wins: 61, losses: 17 },
  { id: 'roman-empire', name: 'The Roman Empire', emoji: '🏛️', wikiTitle: 'Roman_Empire', category: 'ancient empire', tags: ['history','empire','men'], blurb: 'Roads, legions, aqueducts, and the male group chat’s intrusive thought.', score: 1720, wins: 35, losses: 21 },
  { id: 'dinosaurs', name: 'Dinosaurs', emoji: '🦖', wikiTitle: 'Dinosaur', category: 'prehistoric beasts', tags: ['animal','ancient','monster'], blurb: 'Sixty-six million years later and still undefeated in coolness per pound.', score: 1865, wins: 49, losses: 15 },
  { id: 'bitcoin', name: 'Bitcoin', emoji: '₿', wikiTitle: 'Bitcoin', category: 'internet money', tags: ['money','internet','cult'], blurb: 'A spreadsheet with religious properties and laser-eye gravity.', score: 1690, wins: 33, losses: 25 },
  { id: 'ninjas', name: 'Ninjas', emoji: '🥷', wikiTitle: 'Ninja', category: 'stealth operators', blurb: 'If you saw them, no you didn’t.', score: 1744, wins: 37, losses: 16 },
  { id: 'volcanoes', name: 'Volcanoes', emoji: '🌋', wikiTitle: 'Volcano', category: 'earth rage', blurb: 'Planetary pressure release valve. Beautiful, terrifying, extremely metal.', score: 1633, wins: 28, losses: 20 },
  { id: 'synthesizers', name: 'Synthesizers', emoji: '🎛️', wikiTitle: 'Synthesizer', category: 'sound machines', blurb: 'Electricity learning to dream in basslines.', score: 1814, wins: 44, losses: 14 },
  { id: 'sharks', name: 'Sharks', emoji: '🦈', wikiTitle: 'Shark', category: 'ocean hardware', blurb: 'Four hundred million years of patch notes and barely any nerfs.', score: 1666, wins: 31, losses: 19 },
  { id: 'lasers', name: 'Lasers', emoji: '🔴', wikiTitle: 'Laser', category: 'focused light', blurb: 'Light with ambition. Science fiction’s favorite pointer.', score: 1789, wins: 40, losses: 18 },
  { id: 'dragons', name: 'Dragons', emoji: '🐉', wikiTitle: 'Dragon', category: 'mythic apex', blurb: 'Flying reptile billionaires with built-in flamethrowers.', score: 1930, wins: 66, losses: 12 }
];

export const K = 32;

export function expected(a: number, b: number) {
  return 1 / (1 + Math.pow(10, (b - a) / 400));
}

export function applyVote(things: Thing[], winnerId: string, loserId: string) {
  const winner = things.find((t) => t.id === winnerId);
  const loser = things.find((t) => t.id === loserId);
  if (!winner || !loser || winner.id === loser.id) throw new Error('Invalid vote pair');
  const delta = Math.round(K * (1 - expected(winner.score, loser.score)));
  const nextThings = things.map((t) => {
    if (t.id === winnerId) return { ...t, score: t.score + delta, wins: t.wins + 1 };
    if (t.id === loserId) return { ...t, score: Math.max(100, t.score - delta), losses: t.losses + 1 };
    return t;
  });
  return { things: nextThings, delta };
}


export function pickPair(things: Thing[]) {
  const candidates = things.filter(isFunnyEnough);
  const pool = candidates.length >= 8 ? candidates : things;

  // 70%: engineered absurdity — make the algorithm feel like a drunk TV producer.
  if (Math.random() < 0.7) {
    const pair = pickComedyCollision(pool);
    if (pair) return pair;
  }

  const sorted = [...pool].sort((a, b) => b.score - a.score);
  const roll = Math.random();

  // 20%: close ranked fight, but only among interesting nouns.
  if (roll < 0.45 && sorted.length > 3) {
    const start = Math.floor(Math.random() * Math.max(1, sorted.length - 6));
    const window = sorted.slice(start, start + 7);
    return ids(randomFrom(window), randomFrom(window), pool);
  }

  // 35%: weird category collision.
  for (let tries = 0; tries < 50; tries++) {
    const a = randomFrom(pool);
    const b = randomFrom(pool);
    if (a.id !== b.id && !shareTag(a, b) && comedyScore(a, b) >= 2) return [a.id, b.id] as const;
  }

  return ids(randomFrom(pool), randomFrom(pool), pool);
}

function pickComedyCollision(things: Thing[]) {
  let best: readonly [string, string] | null = null;
  let bestScore = -1;
  for (let tries = 0; tries < 80; tries++) {
    const a = randomFrom(things);
    const b = randomFrom(things);
    if (a.id === b.id) continue;
    const score = comedyScore(a, b) + Math.random();
    if (score > bestScore) { bestScore = score; best = [a.id, b.id] as const; }
  }
  return bestScore >= 2 ? best : null;
}

function comedyScore(a: Thing, b: Thing) {
  const at = vibe(a);
  const bt = vibe(b);
  let score = 0;
  if (!shareTag(a, b)) score += 1;
  const combos = [
    ['game', 'concept'], ['game', 'cosmic'], ['game', 'food'], ['game', 'monster'],
    ['food', 'cosmic'], ['food', 'myth'], ['food', 'warrior'], ['food', 'machine'],
    ['monster', 'machine'], ['monster', 'celebrity'], ['myth', 'tech'], ['animal', 'weapon'],
    ['music', 'violence'], ['internet', 'ancient'], ['space', 'snack']
  ];
  if (combos.some(([x, y]) => (at.has(x) && bt.has(y)) || (at.has(y) && bt.has(x)))) score += 4;
  if (absurdName(a.name) || absurdName(b.name)) score += 1;
  if (Math.abs(a.name.length - b.name.length) > 10) score += 0.5;
  return score;
}

function isFunnyEnough(t: Thing) {
  const text = `${t.name} ${t.category} ${(t.tags || []).join(' ')} ${t.blurb}`.toLowerCase();
  if (/election|electoral|constituency|municipal|county|district|parliament|council|ward|village|township|politician/.test(text)) return false;
  return /game|nintendo|sega|playstation|xbox|time|robot|dinosaur|monster|dragon|alien|samurai|ninja|pirate|wizard|laser|black hole|space|star wars|food|pizza|taco|burger|shark|volcano|music|movie|film|comic|superhero|myth|legend|weapon|sword|internet|meme|car|aircraft|roller coaster/.test(text);
}

function vibe(t: Thing) {
  const text = `${t.name} ${t.category} ${(t.tags || []).join(' ')} ${t.blurb}`.toLowerCase();
  const tags = new Set<string>();
  if (/game|nintendo|sega|playstation|xbox|arcade|pokemon|mario|zelda|sonic|tetris/.test(text)) tags.add('game');
  if (/time travel|black hole|concept|internet|meme|civilization|money/.test(text)) tags.add('concept');
  if (/space|star|planet|alien|spaceship|cosmic/.test(text)) tags.add('space'), tags.add('cosmic');
  if (/pizza|taco|burger|cheese|meat|food|snack|chocolate|candy/.test(text)) tags.add('food'), tags.add('snack');
  if (/dragon|monster|godzilla|dinosaur|shark|ghost|terminator/.test(text)) tags.add('monster');
  if (/robot|machine|computer|synthesizer|technology|laser/.test(text)) tags.add('machine'), tags.add('tech');
  if (/samurai|ninja|pirate|wizard|myth|legend|lightsaber|sword/.test(text)) tags.add('myth'), tags.add('warrior'), tags.add('weapon');
  if (/animal|bird|fish|cat|dog|bear|eagle|octopus|whale|snake/.test(text)) tags.add('animal');
  if (/music|band|album|song|metal/.test(text)) tags.add('music');
  if (/film|movie|actor|celebrity|character|superhero|comic/.test(text)) tags.add('celebrity');
  if (/war|battle|violence|weapon|sword/.test(text)) tags.add('violence');
  if (/empire|ancient|roman|medieval/.test(text)) tags.add('ancient');
  return tags;
}

function absurdName(name: string) {
  return /64|time|godzilla|laser|wizard|dragon|pizza|taco|mortal|street|sonic|batman|spider|black hole/i.test(name);
}

function ids(a: Thing, b: Thing, pool: Thing[] = STARTING_THINGS) {
  while (a.id === b.id) b = randomFrom(pool);
  return [a.id, b.id] as const;
}

function randomFrom<T>(items: T[]) {
  return items[Math.floor(Math.random() * items.length)];
}

function shareTag(a: Thing, b: Thing) {
  const left = new Set(a.tags || [a.category]);
  return (b.tags || [b.category]).some((tag) => left.has(tag));
}

export function matchupLine(a: Thing, b: Thing) {
  const lines = [
    `${a.name} vs ${b.name}: a lawsuit against common sense.`,
    `Tonight's scientific question: ${a.name}, or ${b.name}? Nobel committee trembling.`,
    `${a.name} has entered the steel cage with ${b.name}. HR has been notified.`,
    `One of these belongs in history. The other also does, unfortunately.`,
    `A deeply unfair comparison, which is exactly why it matters.`,
    `The database coughed this matchup out and now we all have to live with it.`
  ];
  return lines[Math.floor(Math.random() * lines.length)];
}

export function winnerLine(winner: Thing, loser: Thing, delta: number) {
  const lines = [
    `${winner.name} gains +${delta}. ${loser.name} escorted from the arena by low-paid goblins.`,
    `${winner.name} wins. ${loser.name} will be re-ranked in the basement where it belongs.`,
    `The people have spoken: ${winner.name} is more awesome. ${loser.name} is requesting a recount and a snack.`,
    `${winner.name} detonates ${loser.name}. This is now canon.`,
    `${winner.name} climbs +${delta}. ${loser.name} has been converted into educational content.`
  ];
  return lines[Math.floor(Math.random() * lines.length)];
}

export function infoLine(thing: Thing) {
  const lines = [
    `${thing.name}: ${thing.blurb}`,
    `${thing.name} is filed under “${thing.category},” which sounds fake but is legally binding here.`,
    `Wikipedia says ${thing.name} exists. The Awesomeness Court will decide if that was a good idea.`
  ];
  return lines[Math.floor(Math.random() * lines.length)];
}
